import React from 'react';
import DOMPurify from 'dompurify';
import AlertCircle from '../../../../resources/images/alert-circle-black.svg';

const Banner = ({ title, message, phone, className = '' }) => {
    return (
        <section className={`delinquentbanner ${className}`} tabIndex="0" aria-live="polite">
            <div className="container delinquentbanner__container">
                <AlertCircle className="delinquentbanner__icon" tabIndex="-1" aria-hidden={true} />
                <div className="delinquentbanner__content">
                    {title && <strong>{title}</strong>}{' '}
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message)}} />
                    {phone && (
                        <a href={`tel:${phone}`} title="call for help">
                            {phone}
                        </a>
                    )}
                </div>
            </div>
        </section>
    );
};

export default React.memo(Banner);
